import { RouteObject } from "@/types";
import { Route, Routes } from "react-router-dom";
import NoLayout from "@/layouts/NoLayout";
import AuthLayout from "@/layouts/AuthLayout.tsx";
import PrivateRoute from "@/layouts/PrivateRoute";
import useRouteObjects from "@/routes/RoutesObject";
import DashboardLayout from "@/layouts/DashboardLayout.tsx";

const EDS_BASE_ROUTE = import.meta.env.EDS_BASE_ROUTE;

const AllRoutes = () => {
  const { absolutePathChildren, dashboardChildren, absolutePathChildrenV3 } =
    useRouteObjects();

  const routes: { routes: RouteObject[] } = {
    routes: [
      {
        path: EDS_BASE_ROUTE,
        element: <AuthLayout />,
        children: absolutePathChildren,
      },
      {
        path: EDS_BASE_ROUTE + "dashboard",
        element: (
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        ),
        children: dashboardChildren,
      },
      {
        path: EDS_BASE_ROUTE,
        element: <NoLayout />,
        children: absolutePathChildrenV3,
      },
    ],
  };

  const renderRoutes = (routesFiles: RouteObject[]) =>
    routesFiles.map((route, index) => {
      const { path, element, children } = route;

      if (children) {
        return (
          <Route key={index} path={path} element={element}>
            {renderRoutes(children)}
          </Route>
        );
      }

      return <Route key={index} path={path} element={element} />;
    });

  return <Routes>{renderRoutes(routes.routes)}</Routes>;
};

export default AllRoutes;
